import React, { useState } from 'react';
import { useSettings } from '../context/SettingsContext';

/**
 * Logo robusto con fallback. Si la URL falla a cargar, muestra un círculo
 * rosa con la letra "G" (mismo estilo que cuando settings.logo_url está vacío).
 * Evita el ícono roto de Safari/Chrome en redes inestables.
 */
export default function LogoImage({ size = 'h-12 w-12', alt = 'Gifts GT', rounded = 'rounded-none', shape = 'circle' }) {
  const { settings } = useSettings();
  const [failed, setFailed] = useState(false);
  const showFallback = !settings.logo_url || failed;

  if (showFallback) {
    return (
      <div
        aria-label={alt}
        role="img"
        className={`${size} ${shape === 'circle' ? 'rounded-full' : rounded} bg-gradient-to-br from-pinky-400 to-pinky-500 flex items-center justify-center text-white font-display flex-shrink-0`}
      >
        <span className="text-[1.4em] leading-none">G</span>
      </div>
    );
  }

  return (
    <img
      src={settings.logo_url}
      alt={alt}
      onError={() => setFailed(true)}
      className={`${size} object-contain flex-shrink-0`}
      loading="eager"
      decoding="async"
    />
  );
}
